import { useEffect, useState } from "react";
import { useAuth } from "@boundary/_hooks";
import styles from "./otpRetryButton.module.scss";

const COOLDOWN_TIMEOUT = 60;

interface OtpRetryButtonProps {
  phone: string;
}

export function OtpRetryButton({ phone }: OtpRetryButtonProps) {
  const { requestOtp } = useAuth();
  const [cooldown, setCooldown] = useState(COOLDOWN_TIMEOUT);

  useEffect(() => {
    if (cooldown <= 0) return;
    const intervalId = setInterval(() => setCooldown((c) => c - 1), 1000);
    return () => clearInterval(intervalId);
  }, [cooldown]);

  const handleResend = async () => {
    console.log(`[Button Click] OtpRetryButton: "Отправить код ещё раз" (phone: ${phone}, cooldown: ${cooldown})`);
    setCooldown(COOLDOWN_TIMEOUT);
    await requestOtp(phone);
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <button
      disabled={cooldown > 0}
      onClick={handleResend}
      className={styles.button}
      type="button"
    >
      {cooldown > 0 ? `Запросить повторно можно через ${formatTime(cooldown)}` : "Отправить код ещё раз"}
    </button>
  );
}

